<template>
  <div class="logs-details">
    <PageHeader :title="title" />

    <VLoader v-if="isLoading" />
    <div v-else>
      <VEmpty v-if="!logData" title="Нет данных" />
      <div v-else>
        <ul class="logs-details__list">
          <li>
            <span>Действие</span>
            <span>{{ renderAction(logData.action) }}</span>
          </li>
          <li>
            <span>Дата:</span>
            <span>{{ new Date(logData.created_at).toLocaleString() }}</span>
          </li>
          <li>
            <span>Пользователь</span>
            <span>{{ logData.user.name }} ({{logData.user.email}})</span>
          </li>
          <li>
            <span>Сущность</span>
            <span>{{  renderEntity(logData.entity_type) }}</span>
          </li>
          <li>
            <span>Тип пользователя:</span>
            <span>{{ logData.user_type }}</span>
          </li>
          <li>
            <span>IP адрес:</span>
            <span>{{ logData.ip_address }}</span>
          </li>
          <li>
            <span>User Agent:</span>
            <span>{{ logData.user_agent }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { mapActions, mapEntity } from '@/constants/app';

import api from "@/api";

import VLoader from "@/ui-kit/components/VLoader";
import VEmpty from "@/ui-kit/components/VEmpty.vue";
import PageHeader from "@/components/page/PageHeader.vue";

const title = "Информация о логе";
const route = useRoute();
const logData = ref(null);
const isLoading = ref(true);

const getData = async () => {
  try {
    isLoading.value = true;
    const logId = route.params.id;
    const { data } = await api.logs.getDetail(logId);
    logData.value = data.data;
  } catch (err) {
    console.error(err);
    logData.value = {};

  } finally {
    isLoading.value = false;
  }
};

const renderAction = (action) => {
  return mapActions[action] || ''
}

const renderEntity = (item) => {
  return mapEntity[item] || ''
}

onMounted(() => {
  getData();
});
</script>

<style lang="scss" scoped>
.logs-details {
    &__list {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding-left: 0;

        & li {
            display: grid;
            grid-template-columns: 150px auto;
            gap: .5rem;
            font-size: 14px;
        }
    }
}
</style>